<template>
  <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
    <span class="material-icons text-5xl text-neutral-400 dark:text-neutral-600" aria-hidden="true">{{ icon }}</span>
    <h3 class="mt-3 text-base font-semibold text-neutral-900 dark:text-neutral-100">{{ title }}</h3>
    <p v-if="message" class="mt-1 text-sm text-neutral-600 dark:text-neutral-400 max-w-md">{{ message }}</p>
    <div v-if="$slots.default" class="mt-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: String,
      default: "inbox",
    },
    title: {
      type: String,
      default: "Nothing here yet",
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>
